import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Validators } from '@angular/forms';

import { Textbox } from './../../models/editors/textbox.model';
import { Textarea } from './../../models/editors/textarea.model';

import { ApiService } from './../../shared/services/api.service';
import { FormControlService } from './../../shared/services/form-control.service';
import { AlertService } from './../../shared/services/alert.service';
import { ContainedMany } from './../../models/editors/contained-many.model';
import { FormDetailBase } from './../../shared/components/base/form-detail/form-detail.base.component';
import { atLeastOneLang } from './../../shared/validators/langField.validator';
import { EntityService } from './../../shared/services/entity.service';
import { Office } from '../../models/offices/offices.model';
import { Contained } from '../../models/editors/contained.model';

@Component({
  selector: 'swb-office-detail',
  templateUrl: './../../shared/components/base/form-detail/form-detail.base.component.html',
  providers: [FormControlService]
})
export class OfficeDetailComponent extends FormDetailBase<Office> implements OnInit {

  public entity = new Office({});

  public get fieldsConfig(): Array<any> {
    if (this.isModal) {
      return [
        new Textbox({
          key: 'title',
          label: 'Titulek',
          validators: atLeastOneLang,
          isMultilang: true
        }),
        new Textbox({
          key: 'sorter',
          type: 'number',
          label: 'Pořadí (kategorie se seřadí vzestupně podle těchto čísel)',
          validators: [Validators.required],
          defaultValue: 99
        })
      ];
    } else {
      return [
        new Textbox({
          key: 'title',
          label: 'Titulek',
          validators: atLeastOneLang,
          isMultilang: true
        }),
        new Textbox({
          key: 'sorter',
          type: 'number',
          label: 'Pořadí (kategorie se seřadí vzestupně podle těchto čísel)',
          validators: [Validators.required],
          defaultValue: 99
        }),
        new Textarea({
          key: 'content',
          label: 'Popisek',
          isMultilang: true,
          wysiwyg: 'person-category-detail'
        }),
        new ContainedMany({
          key: 'office_contacts',
          label: 'Kontaktní osoby',
          entities: this.entity.office_contacts,
          upload: false,
          apiUrl: 'office-contacts',
          canCreate: true
        }),
        new Contained({
          key: 'file_id',
          label: 'Obrázek',
          upload: true,
          entity: this.entity.file
        })
      ];
    }
  }

  public url = 'offices';
  protected _redirect = 'contacts';

  constructor(
    _formService: FormControlService,
    _apiService: ApiService,
    _router: Router,
    _alertService: AlertService,
    private _route: ActivatedRoute,
    private _entityService: EntityService
  ) {
    super(
      _formService,
      _apiService,
      _router,
      _alertService
    );
  }

  ngOnInit() {

    if (typeof this._route.snapshot.params['id'] !== 'undefined' && this._route.outlet !== 'modal-form') {
      this._id = this._route.snapshot.params['id'];
    }

    if (this._route.outlet === 'modal-form') {
      this.isModal = true;
      this._redirect = undefined;
      this._saveCallback = this._saveCallback = (response) => {
        const item = { ...response }.data;
        this._entityService.setChosenEntities([item], 'offices');
        this._closeCallback();
      };
      this._closeCallback = () => {
        this._router.navigate([{ outlets: { 'modal-form': null } }], {
          relativeTo: this._route.parent
        });
      };
      window.scrollTo(0, 0);
    }


    this._getEntity();

  }

}
